import React, { useEffect, useState } from "react";
import ImmunizationAttachment from "../modals/ImmunizationAttachments";
import { formatDate } from "../../utility/general";
import { get } from "../../utility/fetch";
import toast from "react-hot-toast";

function ImmunizationTable({ patientId }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [data, setData] = useState([]);
  const [isloading, setIsLoading] = useState(false);

  const downloadFile = async (docName) => {
    try {
      // Get the token from local storage
      const token = sessionStorage.getItem("token").split("Bearer ")[1];

      // If token is not available, handle accordingly
      if (!token) {
        console.error("Token not found in session storage");
        return null;
      }

      // Construct the URL with the document name
      const url = `https://api.greenzonetechnologies.com.ng/labapi/api/document/download-document/${docName}`;

      // Fetch options including the Authorization header with the JWT token
      const options = {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      // Fetch the file
      const response = await fetch(url, options);

      // Check if the request was successful
      if (response.ok) {
        // Convert response body to a blob
        const blob = await response.blob();

        // Create a URL for the blob
        const blobUrl = URL.createObjectURL(blob);

        // Trigger download by creating an anchor element
        const anchor = document.createElement("a");
        anchor.href = blobUrl;
        anchor.download = docName; // Set the filename for download
        anchor.click();

        // Clean up by revoking the blob URL
        URL.revokeObjectURL(blobUrl);
      } else {
        toast.error("Failed to Download/ Invalid Document");
        console.error("Failed to fetch download link:", response.statusText);
      }
    } catch (e) {
      console.error("Error fetching download link:", e);
    }
  };

  const fetchData = async () => {
    console.log(patientId);
    setIsLoading(true);
    try {
      const response = await get(
        `/patients/GetAllImmunizationRecordByPatientId/`,
        { patientId: patientId },
      );

      setData(response.data);
    } catch (e) {
      console.log(e);
    }

    setIsLoading(false);
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const stageAttachments = (data) => {
    setAttachments(data);
    toggleModal();
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="w-100 ">
      {!isloading ? (
        <div
          className="w-100 none-flex-item m-t-40"
          style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
        >
          <table className="bordered-table-2" style={{ minWidth: "900px" }}>
            <thead className="border-top-none">
              <tr className="border-top-none">
                <th
                  className="w-10"
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Vaccine
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Quantity
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Age
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Weight
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Temp
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Brand
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Admin nurse
                </th>
                <th
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Vaccine Batch ID
                </th>
                <th
                  className=" w-20"
                  style={{
                    whiteSpace: "nowrap",
                    fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)",
                  }}
                >
                  Attachment
                </th>
              </tr>
            </thead>
            <tbody className="white-bg view-det-pane">
              {data.map((row) => (
                <tr key={row.id}>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {formatDate(row?.dateGiven)}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.vaccine}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.quantity}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.age}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.weight}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.temperature}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.vaccineBrand}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.nurseName}
                  </td>
                  <td style={{ fontSize: "clamp(0.7rem, 2.5vw, 0.875rem)" }}>
                    {row?.batchId}
                  </td>
                  <td
                    className="font-xs"
                    style={{ fontSize: "clamp(0.65rem, 2vw, 0.75rem)" }}
                  >
                    {row?.immunizationDocuments && (
                      <div>
                        {row?.immunizationDocuments.map((doc, index) => (
                          <p
                            key={index}
                            onClick={() => downloadFile(doc?.docName)}
                            className="pointer font-link"
                          >
                            Download Attachment
                          </p>
                        ))}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div>Loading....</div>
      )}

      {modalOpen && (
        <ImmunizationAttachment closeModal={toggleModal} data={attachments} />
      )}
    </div>
  );
}

export default ImmunizationTable;
